<template>
   <div>
      <PageHeader :title="$t('pages.download.title')" :desc="$t('pages.download.desc')"/>
      <PageFrameContainer>
         <div v-if="ctx != null">
            <div class="product-cell" v-for="product in productKeys" :key="product">
               <div v-if="product.toLowerCase()==='bw1player'">
                  <h2>{{product | productNameFilter}}</h2>
                  <h3>{{$t('pages.download.playerSection.title')}}</h3>
                  <p>
                     {{$t('pages.download.playerSection.text')}}
                  </p>
               </div>
               <div v-else>
                   <h4>{{product | productNameFilter}}</h4>
               </div>
               <div class="versions-table">
                  <img class="product-logo" :src="getLogoPath(product)">
                  <div class="versions-container">
                     <div class="versions-container-cells-header">
                     </div>
                     <label class="versions-container-cell-platform header">{{$t('pages.download.tableComponents.platform')}}</label>
                     <label class="versions-container-cell-date header">{{$t('pages.download.tableComponents.date')}}</label>
                     <label class="versions-container-cell-ver header">{{$t('pages.download.tableComponents.version')}}</label>
                     <label class="versions-container-cell-size header">{{$t('pages.download.tableComponents.size')}}</label>
                     <label class="versions-container-cell-download header"></label>

                     <template v-for="(platform, index) in Object.keys(ctx[product])">
                        <label :key="'platform-'+index" class="versions-container-cell-platform"
                               :style="{ gridRow:2+index}">{{platform|platformTitleFilter}}</label>
                        <label :key="'ver-'+index" class="versions-container-cell-ver"
                               :style="{ gridRow:2+index}">{{ctx[product][platform].ver}}</label>
                        <label :key="'size-'+index" class="versions-container-cell-size"
                               :style="{ gridRow:2+index}">{{ctx[product][platform].size | sizeMBFilter}}
                           Mb</label>
                        <label :key="'date-'+index" class="versions-container-cell-date"
                               :style="{ gridRow:2+index}">{{ctx[product][platform].date}}</label>

                        <router-link v-if="product.toLowerCase()==='bw1player'"
                                     :key="'link-'+index"
                                     tag="button"
                                     :to="{ name: 'download', params: {product: product, version:ctx[product][platform].ver, platform:platform, installerType:'OfflineInstaller' } }"
                                     class="versions-container-cell-download" :style="{ gridRow:2+index}"
                                     title="download">
                           {{$t('pages.download.tableComponents.download')}} {{platform|platformTitleFilter}}
                        </router-link>
                        <router-link v-else
                                     :key="'link-'+index"
                                     tag="button"
                                     :to="{ name: 'download', params: {product: product, version:ctx[product][platform].ver, platform:platform, installerType:'OfflineInstaller' } }"
                                     class="versions-container-cell-download-slave" :style="{ gridRow:2+index}"
                                     title="download">
                           {{$t('pages.download.tableComponents.download')}} {{platform|platformTitleFilter}}
                        </router-link>
                     </template>

                  </div>

               </div>
               <div v-if="product.toLowerCase()==='bw1player'" class="archive">
                  <router-link class="router-link-archive" title="archive" tag="a"
                               :to="{ name: 'archive', params: {product: product, platform: 'WinX86', installerType: 'OfflineInstaller',stable: true } }">
                     {{$t('pages.download.tableComponents.archive')}}&nbsp;&rarr;
                  </router-link>
                  <div class="versions-track" :key="`${product}-track`"></div>
                  <h2>
                     {{$t('pages.download.appSection.title')}}
                  </h2>
                  <h3>
                     {{$t('pages.download.appSection.desc')}}
                  </h3>
                  <p>
                     {{$t('pages.download.appSection.text')}}
                  </p>

               </div>
               <div v-if="product.toLowerCase()!=='bw1player'" class="archive">
                  <router-link class="router-link-archive-slave" title="archive" tag="a"
                               :to="{ name: 'archive', params: {product: product, platform: 'WinX86', installerType: 'OfflineInstaller',stable: true } }">
                     {{$t('pages.download.tableComponents.archive')}}&nbsp;&rarr;
                  </router-link>
               </div>
            </div>
         </div>
      </PageFrameContainer>
   </div>
</template>

<script>
    import PageFrameContainer from "./components/PageFrameContainer";
    import PageHeader from "./components/PageHeader";

    let artefactDb = require('./assets/data/db');
    export default {
        name: "DownloadHomePage",
        components: {PageHeader, PageFrameContainer},
        props: {
            ctx: {},
        },
        data:function(){
            return{
                productKeys:['BW1Player','BW1Studio','UrlEditor','BW1Mapper','BWClockServer']
            }
        },
        mounted: async function () {
            let db = artefactDb;
            let obj = {};
            let products = Object.keys(db);
            for (let p of products) {
                let productData = db[p];
                let platforms = Object.keys(productData);
                platforms.sort();

                let platformsList = {};
                let listIsEmpty = true;
                for (let pl of platforms.reverse()) {
                    let types = productData[pl];
                    if (Object.prototype.hasOwnProperty.call(types, 'OfflineInstaller')) {

                        let versions = types['OfflineInstaller'];
                        versions.sort((_x, _y) => {
                            let x = Date.parse(_x.date);
                            let y = Date.parse(_y.date);
                            return y - x;
                        });
                        for (let artefact of versions) {
                            //console.info(`${pl}, ${artefact.stable}`);
                            if (artefact['stable'] === 1) {
                                platformsList[pl] = {
                                    ver: artefact.ver,
                                    size: artefact.size,
                                    date: artefact.date,
                                    link: artefact.link
                                };
                                listIsEmpty = false;
                                break;
                            }
                        }
                    }
                }
                if (listIsEmpty === false)
                    obj[p] = platformsList;
            }
            this.ctx = obj;
        },
        methods: {
            getLogoPath: function (_product) {
                try {

                    let logo = require(`@/assets/icons/products/${_product.replace(/ /g, '-').toLowerCase()}.svg`);
                    if (logo == null)
                        return '';
                    return logo;
                } catch {
                    return '';
                }
                //`./assets/icons/${_product}_logo.svg`
            }
        },
        filters: {
            platformTitleFilter(value) {
                switch (value.toLowerCase()) {
                    case "winx86":
                        return "32 bit";
                    case "winx64":
                        return "64 bit";
                    default:
                        return value;
                }
            },
            sizeMBFilter(value) {
                return Math.round(value / 1024 / 1024);
            }
        }
    }
</script>

<style scoped lang="scss">
   @import "/theme/theme.scss";

   /*
   --------------------------------------------------------------------------------
   PAGE
   --------------------------------------------------------------------------------
   */
   .page-container {
      display: grid;
      grid-template-columns: 1fr auto 1fr;
      grid-template-rows: auto 1em auto 1fr;
      width: 100%;
      height: 100%;


   }

   .product-cell {
      //margin-top: 1em;
      margin-bottom: 2rem;

      h3 {
         margin-top: 1rem;
         font-size: 1.2rem;
         font-weight: 400;
      }

      h4 {
         font-size: 1.7rem;
         font-weight: 300;
         color: $primary20;
      }

      p {
         margin-top: 0.5rem;
         font-size: 1rem;
         font-weight: 300;
      }

      .versions-track {
         z-index: -1;
         grid-column: 1/-1;
         margin-bottom: 1rem;
         margin-top: 1rem;
      }
   }

   h2 {
      font-size: 2em;
      color: $primary20;
      text-align: left;
      font-weight: 300;
      //background: linear-gradient(to right, white, #3d9be8);
   }

   @media (max-width: 40em) {
      h2 {
         font-size: 1.5em;
      }
   }

   @media (max-width: 20em) {
      h2 {
         font-size: 1em;
      }
   }

   h2 a {
      text-decoration: none;
      font-size: 0.5em;
      color: $text40;
      padding-left: 0.4em;
      border-left: 1px solid $text20;

   }

   h2 a:hover {
      color: $accent60;
   }

   .archive {
      display: grid;
   }

   a.router-link-archive {
      font-size: 0.9em;
      color: $text100;
      vertical-align: middle;
      text-decoration: none;
      text-effect: none;
      cursor: pointer;
      justify-self: right;
      margin-top: 0.5rem;
      margin-right: 3rem;
      border-bottom: 1px solid $primaryText100;
   }

   a.router-link-archive:hover {
      //background: $primary40;
      border-bottom: 1px solid $text60;
      color: $text80;
   }

   a.router-link-archive-slave {
      font-size: 0.9em;
      color: $text80;
      vertical-align: middle;
      text-decoration: none;
      text-effect: none;
      cursor: pointer;
      justify-self: right;
      margin-top: 0.5rem;
      margin-right: 3rem;
      border-bottom: 1px solid $primaryText100;
   }

   a.router-link-archive-slave:hover {
      //background: $primary100;
      border-bottom: 1px solid $text60;
   }

   .h3 {
      font-size: 1.0em;
      color: $primary40;
      text-align: left;
   }

   /*
   --------------------------------------------------------------------------------
   Versions table
   --------------------------------------------------------------------------------
   */
   .versions-table {
      display: grid;
      grid-template-columns: minmax(auto, 10em) auto;
      grid-template-rows: auto;
      margin: 0 auto;
      margin-top: 1em;
      border: 1px solid $text20;
      border-radius: 0.3rem;
   }

   .product-logo {
      grid-column: 1;
      width: 4em;
      margin-left: auto;
      margin-right: auto;
      margin-top: auto;
      margin-bottom: auto;

   }

   @media (max-width: 40em) {
      .product-logo {
         width: 3em;
      }
   }

   @media (max-width: 20em) {
      .product-logo {
         width: 2em;
      }
   }

   .versions-container {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
      grid-column: 2;
      grid-row: 1;
      display: grid;
      grid-template-columns: auto auto auto auto auto;
      grid-template-rows: auto;
      grid-row-gap: 0.6em;
      grid-column-gap: 0.4em;
      border-left: 0.1em solid $text10;
   }

   @media (max-width: 40em) {
      .versions-container {
         font-size: 0.7em;
      }
   }

   @media (max-width: 20em) {
      .versions-container {
         font-size: 0.5em;
      }
   }

   .versions-container label {
      font-size: 1.1em;
      text-align: center;
      margin-bottom: auto;
      margin-top: auto;
   }

   .versions-container a {
      font-size: 1.2em;
      text-align: center;
      text-decoration: none;
      border-bottom: 0;
      color: $primary40;
      margin: auto;
   }

   .versions-container a img {
      display: block;
      height: 1.2em;
      align-self: center;
   }

   .versions-container a:hover {
      color: $primary60;
   }

   .versions-container .header {
      grid-row: 1;
      text-transform: uppercase;
      font-size: 0.8em;
      color: $text60;
   }

   .versions-container-cell-platform {
      grid-column: 1;

   }

   .versions-container-cell-ver {
      grid-column: 2;
   }

   .versions-container-cell-size {
      grid-column: 3;
   }

   .versions-container-cell-date {
      grid-column: 4;
   }

   button.versions-container-cell-download {
      grid-column: 5;
      padding: 0.7em 2em;
      background: $primary100;
      border-radius: 0.4em;
      border-color: $back20;
      border-width: 1px;
      border-style: solid;
      text-decoration: none;
      text-effect: none;
      font-size: 0.9em;
      cursor: pointer;
      color: $primaryText100;
      justify-self: center;
      outline: none;
   }

   button.versions-container-cell-download:hover {
      background: $primary20;
   }

   button.versions-container-cell-download-slave {
      grid-column: 5;
      padding: 0.7em 2em;
      background: $primaryText100;
      border-radius: 0.4em;
      border-color: $primary40;
      border-width: 1px;
      border-style: solid;
      text-decoration: none;
      text-effect: none;
      font-size: 0.9em;
      cursor: pointer;
      color: $primary100;
      justify-self: center;
      outline: none;
   }

   button.versions-container-cell-download-slave:hover {
      background: $primary100;
      color: $primaryText100;
   }

   .versions-container-cell-download img {
   }


</style>